import * as z from "zod";

export const autoMergeSpecifiedGroups = {
  name: "autoMergeSpecifiedGroups" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({}),
};
